<template>
  <div class="section">
    <div class="loader" />
  </div>
</template>

<script>
  import errorHandlers from '@/services/error-handlers';

  export default {
    name: 'AutoStartOrderPage',

    created() {
      this.createdHandler();
    },

    methods: {
      async createdHandler() {
        await this.$store.dispatch('locations/getLocationConditionally', { withMenu: true });

        this.unsetOrder();

        await this.updateOrderDetails();

        await this.$store.dispatch('locations/validateSelectedLocationWithOrderDetails');

        this.$router.replace({
          name: 'order',
          params: {
            merchantId: this.$route.params.merchantId
          }
        });
      },

      async updateOrderDetails() {
        try {
          let fulfillmentType = this.$route.query.ft || 'pick-up';
          const menuType = this.$route.query.mt || null;
          const orderType = this.$route.query.mt?.toLowerCase() === 'catering' ? 'catering' : 'standard';
          const tableNumber = this.$route.query.tb || null;

          if (['delivery', 'shipping'].includes(fulfillmentType)) {
            this.$openModal('editOrderDetails', {
              fulfillmentType
            });

            fulfillmentType = 'pick-up';
          }

          await this.$store.dispatch('orders/updateOrder', {
            fulfillmentType,
            menuType,
            orderType,
            tableNumber
          });
        }

        catch (error) {
          errorHandlers.silent(error);
        }
      },

      unsetOrder() {
        this.$store.dispatch('session/unsetOrder', { doNotRefreshMenu: true });
      }
    }
  };
</script>
